@use "Styles/mixins";

:host {
    overflow: hidden;
    position: relative;

    * {
        box-sizing: border-box;
    }

    .vm-slider {
        &__content {
            display: flex;
            gap: var(--vm-slider-gap, 16px);
            overflow-x: auto;
            scroll-snap-type: x mandatory;
            scroll-behavior: smooth;
            scroll-padding-left: 16px;
            list-style-type: none;
            padding: 0;
            padding-inline: 16px;
            margin: 0;
            scrollbar-width: none;

            @include mixins.desktop-and-up() {
                scroll-padding-left: 24px;
                padding-inline: 24px;
            }

            @media (pointer: fine) {
                // Fade both edges when both controls are visible
                &.vm-slider__content--prev-enabled.vm-slider__content--next-enabled {
                    mask-image:
                        linear-gradient(to right, transparent, black 48px),
                        linear-gradient(to left, transparent, black 48px);
                    mask-composite: intersect;
                }

                // Fade left edge only when prev control is visible
                &.vm-slider__content--prev-enabled.vm-slider__content--next-disabled {
                    mask-image: linear-gradient(to right, transparent, black 48px);
                }

                // Fade right edge only when next control is visible
                &.vm-slider__content--prev-disabled.vm-slider__content--next-enabled {
                    mask-image: linear-gradient(to left, transparent, black 48px);
                }
            }

            ::slotted(*) {
                scroll-snap-align: start;
                scroll-snap-stop: normal;
            }
        }

        &__control {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;

            @media (pointer: coarse) {
                display: none;
            }

            &[hidden] {
                display: none;
            }

            &--prev {
                left: 24px;
            }

            &--next {
                right: 24px;
            }
        }
    }
}

:host([orientation="vertical"]) {
    display: flex;
    flex-direction: column;
    min-height: 0;

    .vm-slider__content {
        flex: 1 1 auto;
        min-height: 0;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        scroll-snap-type: none;
        padding: var(--vm-slider-padding, 0);
        scroll-padding: var(--vm-slider-padding, 0);

        ::slotted(*) {
            flex-shrink: 0;
        }
    }
}
